<!--
 * @Author: Src
 * @Date: 2024-12-17 19:09:43
 * @LastEditTime: 2024-12-25 18:16:16
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/shop/DetailShop.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div>
        <TopTitle>
            <template #left>
                <div>
                    <el-button type="text" @click="back">返回</el-button>
                </div>
            </template>
            <template #center>
                <div>门店详情</div>
            </template>
        </TopTitle>
        <BooyComponent>
            <el-form :model="form" label-width="100px" ref="ruleForm" :rules="rules">
                <el-form-item v-for="item in initShopFields" :key="item.label" :label="item.labelName" :prop="item.label" :label-width="item.labelWidth">
                    <!-- <component v-model="form[item.label]" :is="getComponent(item.label)" :disabled="true"
                        :regions="citys" :CityId="form.adcode" >
                    </component> -->
                    <span v-if="item.label ===  EShopField.nationalEmblemPhotos">
                        <img :src="form.national_emblem_photos_url" alt="" class="_img">
                    </span>
                    <span v-else-if="item.label === EShopField.portraitPhotos">
                        <img :src="form.portrait_photos_url" alt="" class="_img">
                    </span>
                    <span v-else-if="item.label === EShopField.shopLicense">
                        <img :src="form.shop_license_url" alt="" class="_img">
                    </span>
                    <span v-else-if="item.label === EShopField.city">
                        <span>{{ form.city_name }}</span>
                    </span>
                    <span v-else>{{ form[item.label] }}</span>
                </el-form-item>
            </el-form>
            <!-- <el-button type="primary" @click="submitForm">提交</el-button> -->
        </BooyComponent>
    </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { IShop } from '@/common/interface/shop';
import { ShopFieldFactory } from '@/models/shopFieldFactory';
import CityField from '@/views/shop/comments/CityField.vue';
import InputField from '@/views/shop/comments/InputField.vue';
import UploadField from '@/views/shop/comments/UploadField.vue';
import PickerField from '@/views/shop/comments/PickerField.vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import shopNameField from '@/views/shop/comments/shopNameField.vue';
import TimePickerField from '@/views/shop/comments/TimePickerField.vue';
import { EShopField } from '@/common/enum/shop';
import TopTitle from '@/components/topTitle.vue';
import BooyComponent from '@/components/booyComponent.vue';
interface City {
    code: string; // 城市编号
    depth: number;
    id: number; // 城市id
    name: string;
    pid?: number;
    pinyin: string;
    pinyin2: string;
    province?: City;
}

@Component({
    components: {
        TopTitle,
        BooyComponent
    }
})
export default class AddShop extends Vue {
    form: { [key: string]: any } | any = {};

    citys: City[] = [];

    EShopField = EShopField;

    shopId = '';

    regions: Array<{ id: number; name: string; city: City[] }> = [];

    @lazyInject(ShopService)
    shopService!: ShopService;

    rules: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [k: string]: any[];
    } = {};

    initShopFields: IShop[] = ShopFieldFactory.init();

    mounted() {
        console.log(this.initShopFields);
        console.log('ddddddd');
        // this.shopService.getShopInfo();
        this.shopId = this.$route.params.id;
        this.getCityList();
        this.getDatalist();
    }
    async getDatalist() {
        const response = await this.shopService.getShopDetail(this.shopId);
        this.form = response;
        console.log(response);
    }

    async getCityList() {
        const response = (await this.shopService.getCityList()) as unknown as {
            [key: string]: {
                province: City;
                city: City[];
            };
        };
        if (response) {
            const citys = Object.values(response)
                .map((item) => item.city)
                .reduce((prev, cur) => prev.concat(cur), []);
            this.citys = citys;

            const all = Object.values(response);
            const list: Array<{ id: number; name: string; city: City[] }> = [];
            for (const province of all) {
                list.push({
                    city: province.city,
                    id: province.province ? province.province.id : 0,
                    name: province.province ? province.province.name : '直辖市',
                });
            }
            this.regions = [...list];
        } else {
            this.citys = [];
        }
        console.log(this.regions, this.citys);
    }

    getData() {
        this.getPoi(this.regions[0].id, this.regions[0].name);
    }

    back() {
        this.$router.push('/shop/list');
    }

    async getPoi(regionId: any, keywords: any) {
        const response = (await this.shopService.getPoi(regionId, keywords)) as unknown as any;
        console.log(response);
    }

    setRulesAndFormItems(fields: IShop[]) {

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const rules: any = {};
        for (const field of fields) {
            rules[field.label] =
                field.rule && field.rule.length ? field.rule : undefined;
        }

        const ruleKeys = Object.keys(rules);
        for (const key of ruleKeys) {
            if (rules[key] === undefined) {
                delete rules[key];
            }
        }
        this.rules = rules;
    }

    getComponent(label: string) {
        // console.log(label);
        switch (label) {
            case EShopField.city:
                return CityField;
            case EShopField.nationalEmblemPhotos:
                return UploadField;
            case EShopField.businessYear:
                return PickerField;
            case EShopField.portraitPhotos:
                return UploadField;
            case EShopField.shopLicense:
                return UploadField;
            case EShopField.shopName:
                return shopNameField;
            case EShopField.businessHours:
                return TimePickerField;
            default:
                return InputField;
        }
    }


}
</script>
<style lang="scss" scoped>
._img {
    width: 100px;
}
</style>
